import React from "react";

import {OrderResponseData} from "@globals/DailyOrders/interfaces";

import {ConfirmationModalTrigger} from "@components/modals";

// Returns a ConfirmationModalTrigger with pre-defined texts
// allows us to have a consistent Order Cancel modal in different places;

const CancelOrderText = ({order}: {order: OrderResponseData}): JSX.Element => (
  <div>
    <p>
      The following items for {order.location.name ?? order.location.address}{" "}
      will be cancelled:
    </p>
    {order.order_items.map((item) => (
      <p key={item.id}>
        {item.display_name} x {item.count}
      </p>
    ))}
  </div>
);

interface CancelOrderModalTriggerProps {
  order?: OrderResponseData;
  children: JSX.Element;
  onConfirm: () => void;
}

const CancelOrderModalTrigger = ({
  order,
  children,
  onConfirm,
}: CancelOrderModalTriggerProps): JSX.Element => {
  return (
    <ConfirmationModalTrigger
      title="Are you sure you want to cancel this order?"
      confirmationContent={order && <CancelOrderText order={order} />}
      confirmButtonText="Yes, I'm sure"
      onConfirm={onConfirm}
      cancelButtonText=""
      showCloseButton={true}
    >
      {children}
    </ConfirmationModalTrigger>
  );
};

export default CancelOrderModalTrigger;
